import { getApiUrl } from "@repo/edtech-api";
import { declination } from "@repo/edtech-shared";

import {
  CURRENT_PUBLICATIONID_KEY,
  CURRENT_UNITID_KEY,
  ExtendedLesson,
  Lesson,
  LessonType,
  TestQuestionFrontType,
  UNIT_SOURCE_ID,
  ValidationError,
} from "../model";
import { t } from "../origins";

export const getCourseIds = () => {
  const params = new URLSearchParams(window.location.search);
  const publicationId = params.get(CURRENT_PUBLICATIONID_KEY);
  const unitId = params.get(CURRENT_UNITID_KEY);
  const link = params.get("link");

  return {
    publicationId,
    unitId,
    link,
  };
};

export const isLessonMaterial = (type: LessonType) => {
  return Object.values(LessonType).includes(type);
};

export const isLessonUnit = (elementSource: string) => {
  return elementSource === UNIT_SOURCE_ID;
};

export const isValidLesson = (lesson: ExtendedLesson | Lesson) => {
  return isLessonUnit(lesson?.elementSource) || isLessonMaterial(lesson?.materialType);
};

export const isMaterialSurvey = (survey: string) => {
  return survey === "checked";
};

export const getDescription = (description?: string,
  isSurvey?: boolean) => {
  if (description) return description;
  if (isSurvey) return "Пройдите опрос";
  return t("mainTestCover.notStartedDescription");
};

export const parseAttempts = (raw?: string | null): number | undefined => {
  if (raw == null || raw === "") return undefined;

  const parsed = Number(raw);

  return Number.isFinite(parsed) ?
    parsed :
    undefined;
};

export const getRemainingAttemptsText = (count: number): string => {
  const verb = new Intl.PluralRules("ru-RU").select(count) === "one" ?
    "Осталась" :
    "Осталось";

  return `${verb} ${declination(count, [
    "попытка",
    "попытки",
    "попыток",
  ])}`;
};

export const getJSONPayload = (payload: unknown) => {
  try {
    return JSON.parse((payload as string).replace(/\\"/g, "\""));
  } catch {
    return {};
  }
};

export const replaceBaseUrlForTools = (url: string) => {
  const toolsIndex = url.indexOf("/tools");
  if (toolsIndex === -1) {
    return url;
  }

  const apiUrl = getApiUrl();
  return apiUrl + url.slice(toolsIndex);
};

export const validateAnswer = (
  value: string,
  questionType: TestQuestionFrontType,
  regex?: string,
  info?: string,
): ValidationError => {
  const trimmed = value.trim();

  if (
    (questionType === TestQuestionFrontType.Open ||
      questionType === TestQuestionFrontType.Survey) &&
      !trimmed
  ) {
    return {
      hasError: true,
      message: "Ответ не должен быть пустым",
    };
  }

  if (regex) {
    try {
      const pattern = new RegExp(regex);
      if (!pattern.test(trimmed)) {
        return {
          hasError: true,
          message: info || "Неверный формат",
        };
      }
    } catch (e) {
      console.warn(
        "Ошибка в регулярном выражении:", regex, e,
      );
    }
  }

  return {
    hasError: false,
    message: "",
  };
};

export const parseUserAnswer = (raw?: string) => {
  if (!raw) return {
    rating: null as number | null,
    comment: "",
  };
  const [ r, ...rest ] = raw.split("|");
  const rating = Number(String(r).trim());
  const comment = rest.join("|").trim();
  return {
    rating: Number.isFinite(rating) && rating > 0 ?
      rating :
      null,
    comment,
  };
};

export const buildUserAnswer = (rating: number | null, comment: string) => {
  const text = (comment ?? "").trim();

  if (rating === null) {
    return text ?
      `0 | ${text}` :
      "";
  }

  return `${rating} | ${text}`;
};


export const formatPhone = (phone?: string): string => {
  if (!phone) return "";
  const cleaned = phone.replace(/\D/g, "");
  if (cleaned.length === 11) {
    return `+${cleaned[ 0 ]} ${cleaned.slice(1, 4)} ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
  }
  return phone;
};

export const getParsedJson = (data: string) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    console.error("getParsedJson error", e);
    return {
      error: true,
    };
  }
};
